import { cloneDeep } from 'lodash';

let pageListFile = require.context('@/router', false, /\.js$/);

let arr = [];

pageListFile.keys().map((item) => {
  arr.push(pageListFile(item).default);
});

arr.sort((a, b) => {
  return a.weight - b.weight;
});

export default function getAllRouterList() {
  return cloneDeep(arr);
}
